import { ROUTE_NAMES } from '~/constants/routes';

type UseLoginRouteUtilsReturn = {
    goToLoginPage: VoidFunction;
};

export const useLoginRouteUtils = (): UseLoginRouteUtilsReturn => {
    const route = useRoute();
    const localePath = useLocalePath();

    const goToLoginPage = (): void => {
        navigateTo(localePath({ name: ROUTE_NAMES.LOGIN, query: { redirect: route.fullPath } }));
    };

    return {
        goToLoginPage,
    };
};
